import { render, staticRenderFns } from "./default-shipping-cost.vue?vue&type=template&id=98b46836&scoped=true"
import script from "./default-shipping-cost.vue?vue&type=script&lang=js"
export * from "./default-shipping-cost.vue?vue&type=script&lang=js"
import style0 from "./default-shipping-cost.vue?vue&type=style&index=0&id=98b46836&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98b46836",
  null
  
)

export default component.exports